import React, {useEffect} from 'react'
import {motion, useAnimation} from 'framer-motion'
import Image from 'next/image'
import {logEvent} from '@lib/gtm'

type ServicesProps = {
  animationProps: (delay?: number) => {
    initial: {
      opacity: number
      y: number
    }
    animate: {
      opacity: number
      y: number
    }
    transition: {
      duration: number
      ease: number[]
      delay: number
    }
  }
  scrollTo: (e: React.MouseEvent<HTMLAnchorElement>) => void
}

export const Services = ({animationProps, scrollTo}: ServicesProps) => {
  const controls = useAnimation()
  const BOXS = [
    {
      icon: 'text',
      title: 'Text',
      description: 'จำแนกข้อความ <br/> ตามหมวดหมู่ต่าง ๆ',
      items: [
        'Text Classification',
        'Named Entity Recognition (NER)',
        'Intent Classification',
      ],
    },
    {
      icon: 'speech',
      title: 'Speech',
      description: 'สร้างเสียงจากข้อความ <br/> และแปลงคำพูดให้เป็นข้อความ',
      items: [
        'Speech-to-Text Recognition <br/> การแปลงเสียงพูดเป็นข้อความ',
        'Text-to-Speech Transcription <br/> การแปลงข้อความเป็นเสียงพูด',
      ],
    },
    {
      icon: 'image',
      title: 'Image/VDO',
      description: 'ระบุและติดแท็กชื่อ<br/>วัตถุต่าง ๆ ในรูปภาพหรือวิดีโอ',
      items: [
        'Image Classification <br/> การจำแนกรูปภาพ',
        'Image Segmentation <br/> การแบ่งประเภทข้อมูลรูปภาพ',
        'Image Verification <br/> การยืนยันตัวตนผ่านระบบด้วยรูปภาพ',
        'Object Detection <br/> การตรวจจับวัตถุ',
      ],
    },
  ]

  const LOGO = ['zort', 'visai', 'agoda', 'scb', 'kubota']

  useEffect(() => {
    const element = document.querySelector('.DataLabeling__services')
    const onScroll = () => {
      const elementTop = element.getBoundingClientRect().top
      const windowHeight = window.innerHeight

      if (elementTop < windowHeight * 0.75) {
        controls.start({opacity: 1, y: 0})
      } else {
        controls.start({opacity: 0, y: 50})
      }
    }

    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [controls])

  return (
    <motion.div
      className='DataLabeling__services'
      initial={{opacity: 0, y: 20}}
      animate={controls}
      transition={{duration: 0.1}}
    >
      <div className='DataLabeling__services__title'>
        <h2 className='title-desktop'>
          บริการ <span>Data Labeling</span> หรือ
          การจำแนกข้อมูลที่มีประสิทธิภาพสูง
        </h2>

        <h2 className='title-mobile'>
          บริการ <span>Data Labeling</span> หรือ <br />
          การจำแนกข้อมูลที่มีประสิทธิภาพสูง
        </h2>
      </div>

      <div className='DataLabeling__services__content'>
        {BOXS.map((item, idx) => (
          <div className='DataLabeling__services__content__item' key={idx}>
            <Image
              src={`/images/services/data-labeling/${item.icon}-icon.svg`}
              alt={item.icon}
              width='78px'
              height='80px'
            />
            <h3>{item.title}</h3>
            <div
              dangerouslySetInnerHTML={{__html: item.description}}
              className='description'
            />
            <ul>
              {item.items.map((i, index) => (
                <li key={index}>
                  <div className='item' dangerouslySetInnerHTML={{__html: i}} />
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className='DataLabeling__services__box'>
        <div className='img-desktop'>
          <Image
            src={`/images/services/data-labeling/services-box.png`}
            alt='data labeling'
            width='155px'
            height='106px'
          />
        </div>

        <h2 className='desktop'>
          สัมผัสประสบการณ์
          <span> Data Labeling ที่เหนือระดับโดยผู้เชี่ยวชาญ </span>
        </h2>

        <h2 className='mobile'>
          สัมผัสประสบการณ์ <br />
          <span>Data Labeling </span>
          <br />
          ที่เหนือระดับโดยผู้เชี่ยวชาญ
        </h2>
        <div className='img-mobile'>
          <Image
            src={`/images/services/data-labeling/services-box.png`}
            alt='data labeling'
            width='160px'
            height='110px'
          />
        </div>

        <motion.a
          {...animationProps(0.2)}
          href='#contact'
          onClick={(e) => {
            scrollTo(e)
            logEvent({
              ga: {
                category: 'Data Labeling',
                action: 'Action: Click CTA',
              },
            })
          }}
          className='DataLabeling__services__box__button'
        >
          เริ่มต้นเลย !
        </motion.a>
      </div>
      <div className='DataLabeling__services__logo'>
        {LOGO.map((item, idx) => (
          <div className='DataLabeling__services__logo__img' key={idx}>
            <Image
              src={`/images/services/data-labeling/${item}-logo.svg`}
              alt={item}
              width='160px'
              height='68px'
            />
          </div>
        ))}
      </div>
    </motion.div>
  )
}
